import React from 'react';
import Link from 'gatsby-link'

export default () =>
  <div>
    <p>Here you can find a list of tools that might assist you in your every day workflow.</p>
    <ul>
      <li><Link to="/slugifier/">Slugifier</Link> - Transform any word/sentences into its slug form, useful for link generation</li>

      <li><Link to="/youtuberepeater/">Youtube Repeater</Link> - Repeats a youtube video indefinitely</li>

      {/* <li><Link to="/urlunscrambler">URL Unshortener</Link> - Unscrambles a particular shortened url</li> */}
    </ul>
  </div>


// WEBPACK FOOTER //
// ./src/pages/index.js